import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptyGuarantor({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fill="#E9EDFB"
        fillRule="evenodd"
        d="M179.9 147.5c-42.86 4.43-60.35 17.5-100.9 15.93-47.85-1.86-89.92-36.47-66.05-74.93C31.15 59.16 67 64.5 98 40s63.31-27.7 85.5-14c40 28 90.89 111.73-3.6 121.5"
        clipRule="evenodd"
      />
      <path
        fill="#8F9DD6"
        fillRule="evenodd"
        d="M135.4 156.01c12.74-3.2 26.35-6.63 44.5-8.5 43.23-4.48 56.03-24.42 53.37-47.43-6.35-8.92-17.15-15.62-35.54-13.08-17.85 2.47-31.02 6.21-43.85 9.86C133.9 102.56 114.75 108 80 108c-32.55 0-53.97-11.06-66.37-20.57q-.35.52-.68 1.07c-23.87 38.46 18.2 73.07 66.05 74.93 23.37.9 39.08-3.05 56.4-7.42"
        clipRule="evenodd"
        opacity={0.32}
      />
      <g filter="url(#pic-empty-guarantor_svg__a)">
        <rect
          width={95}
          height={114}
          x={60.53}
          y={37.17}
          fill="#F9FAFA"
          rx={3}
          transform="rotate(-8 60.53 37.17)"
        />
      </g>
      <g filter="url(#pic-empty-guarantor_svg__b)">
        <rect width={95} height={114} x={72} y={27} fill="#fff" rx={3} />
      </g>
      <rect width={24} height={12} x={82} y={44} fill="#CCD2EE" rx={2} />
      <path
        fill="#E3E8E8"
        fillRule="evenodd"
        d="M82 65a1 1 0 011-1h73a1 1 0 011 1v4a1 1 0 01-1 1H83a1 1 0 01-1-1zm0 12a1 1 0 011-1h73a1 1 0 011 1v4a1 1 0 01-1 1H83a1 1 0 01-1-1zm1 12a1 1 0 00-1 1v4a1 1 0 001 1h28a1 1 0 001-1v-4a1 1 0 00-1-1z"
        clipRule="evenodd"
      />
      <path
        fill="#E3E8E8"
        d="M96 105a14 14 0 110 28 14 14 0 010-28m0 1.58a12.41 12.41 0 100 24.83 12.41 12.41 0 000-24.83m7.15 7.25a.8.8 0 011.1.21 9 9 0 011.52 4.96c0 5.12-4.38 9.25-9.77 9.25q-1.74-.01-3.32-.55a.8.8 0 01.51-1.5q1.35.45 2.81.46c4.53 0 8.19-3.44 8.19-7.66 0-1.46-.44-2.86-1.25-4.07a.8.8 0 01.21-1.1M96 109.75q1.74.01 3.35.56a.8.8 0 11-.52 1.5 9 9 0 00-2.83-.47c-4.53 0-8.19 3.44-8.19 7.66 0 1.41.41 2.77 1.17 3.95a.8.8 0 01-1.33.86 9 9 0 01-1.42-4.81c0-5.12 4.38-9.25 9.77-9.25"
      />
      <path
        fill="#6478CB"
        stroke="#56A"
        strokeWidth={3.71}
        d="M200 110.5l-24-8.5-24 8.5s-.26 17.38 5 26.5c4.97 8.62 19 17 19 17s14.03-8.38 19-17c5.26-9.12 5-26.5 5-26.5z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M181.87 123.12h-.68v-3.47c0-3.1-2.51-5.65-5.58-5.65a5.63 5.63 0 00-5.58 5.65v3.47h-.69a2 2 0 00-1.98 2V134a2 2 0 001.98 2.01h12.53a2 2 0 001.99-2.01v-8.86a2 2 0 00-1.99-2.01m-9.36-3.47c0-1.73 1.4-3.14 3.1-3.14s3.1 1.41 3.1 3.14v3.47h-6.2zm3.94 10.68v1.68c0 .47-.38.85-.84.85a.84.84 0 01-.84-.85v-1.68a1.7 1.7 0 01-.83-1.46c0-.94.75-1.7 1.67-1.7s1.67.76 1.67 1.7a1.7 1.7 0 01-.84 1.46"
        clipRule="evenodd"
      />
      <defs>
        <filter
          id="pic-empty-guarantor_svg__a"
          width={117.17}
          height={133.34}
          x={56.92}
          y={22.33}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.207843 0 0 0 0 0.196078 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3485_447" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_3485_447" result="shape" />
        </filter>
        <filter
          id="pic-empty-guarantor_svg__b"
          width={103}
          height={122}
          x={68}
          y={25}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.207843 0 0 0 0 0.196078 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3485_447" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_3485_447" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

SvgPicEmptyGuarantor.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptyGuarantor.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicEmptyGuarantor svgRef={ref} {...props} />
));
export default ForwardRef;
